var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M12.667 0H3.384c-.756 0-1.42.622-1.42 1.358v13.733c0 .247.068.452.179.61.132.19.345.3.573.299.216 0 .446-.096.658-.277l4.153-3.527a.8.8 0 0 1 .505-.172c.191 0 .375.063.504.173l4.14 3.525c.212.182.426.278.641.278.365 0 .72-.28.72-.909V1.358c0-.736-.614-1.358-1.37-1.358"
  }))));
};
export default SvgFavorite;